import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

// Správa MCP tokenů = zásah do nastavení systému → settings.write
// (přísnější než rodičovský admin.panel.access guard).
export const Route = createFileRoute("/dashboard/admin/mcp")({
  beforeLoad: requirePermissionGuard("settings.write"),
});
